var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{staticClass:"doctor-details-card",staticStyle:{"height":"calc(100% - 20px)"},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_vm._t("footer")]},proxy:true}],null,true)},[_c('doctor-details',{attrs:{"doctor":_vm.doctor,"hideBillingDetails":_vm.hideBillingDetails}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }